import type { CityConfig } from "../city-template/types";

export const rexburgConfig: CityConfig = {
  city: "Rexburg",
  state: "Idaho",
  stateAbbr: "ID",
  slug: "rexburg",
  route: "/cities/rexburg",
  title: "Rexburg ID Passport — Expedited & Emergency Service | Fast Passport Center",
  metaDescription: "Expedited and emergency passport services in Rexburg, Idaho — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Rexburg, BYU-Idaho students, Sugar City, St. Anthony, and all Upper Snake River Valley communities.",
  h1: "Expedited Passport Services in Rexburg, ID",
  heroSubtitle: "BYU-Idaho student heading overseas for a study abroad or international internship? Church mission departure coming up in weeks? Upper Valley family trip to Mexico booked for semester break? Rexburg residents — from BYU-I students and faculty to Madison County families to Ashton and St. Anthony community members — trust us for fast, reliable passport processing. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20panoramic%20view%20of%20Rexburg%20Idaho%20with%20BYU-Idaho%20campus%20prominent%20in%20the%20foreground%20featuring%20the%20iconic%20temple%20spire%20against%20a%20dramatic%20sunset%20sky%2C%20Upper%20Snake%20River%20Valley%20landscape%20with%20the%20Teton%20mountain%20range%20visible%20on%20the%20distant%20horizon%2C%20agricultural%20fields%20and%20small%20town%20charm%20in%20southeastern%20Idaho%2C%20warm%20golden%20hour%20light%20with%20beautiful%20cloud%20formations&width=1800&height=700&seq=rexburg-hero-2026&orientation=landscape",
  heroImageAlt: "Rexburg Idaho BYU-Idaho campus with Teton mountains at sunset",
  geoPosition: "43.8260;-111.7897",
  geoPlacename: "Rexburg, Idaho",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Closest regional agency — approximately 550 miles, appointments required",
  },
  nearbyCitiesZips: [
    { name: "Rexburg", zips: "83440, 83460" },
    { name: "Sugar City", zips: "83448" },
    { name: "St. Anthony", zips: "83445" },
    { name: "Ashton", zips: "83420" },
    { name: "Idaho Falls", zips: "83401, 83402, 83404" },
    { name: "Rigby", zips: "83442" },
    { name: "Driggs", zips: "83422" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Upper Valley Emergency Processing", desc: "Reserved courier access — as fast as 24 hours for Rexburg and Madison County travelers with immediate international departures from Idaho Falls Airport." },
    { icon: "ri-flight-takeoff-line", title: "IDA Airport & SLC Connection Expertise", desc: "Idaho Falls Regional Airport is 30 minutes away with connections to Salt Lake City, Denver, and beyond. We know schedules for Upper Valley travelers connecting to international hubs." },
    { icon: "ri-graduation-cap-line", title: "BYU-Idaho Student & Missionary Focus", desc: "With over 20,000 students, BYU-I generates more international travel per capita than nearly any university. Study abroad, international internships, church missions — we understand these timelines intimately." },
    { icon: "ri-home-heart-line", title: "Upper Snake River Valley Family Specialists", desc: "From first-time passports for Sugar City kids to renewals for St. Anthony families visiting relatives abroad — we make the process clear, fast, and stress-free for the entire Upper Valley." },
  ],
  internalLinks: [
    { name: "Fast passport services in Idaho Falls, ID", route: "/cities/idaho-falls" },
    { name: "Expedited services in Pocatello, ID", route: "/cities/pocatello" },
    { name: "Idaho passport services overview", route: "/states/idaho" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Rexburg via secure registered courier with direct access to State Department processing. Our registered couriers hand-deliver your documents — meaning Rexburg residents get faster results without driving to Denver. Ship from any UPS Store, FedEx Office, or post office in Madison County.",
  fpcOfficeDistance: "Serving Rexburg, Sugar City, St. Anthony, Ashton, Rigby, Driggs, and all Upper Snake River Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Rexburg and the Upper Snake River Valley. From the BYU-Idaho campus to the historic downtown, from Sugar City to the Teton Valley communities — we serve all of Madison County and beyond. Our courier service eliminates the need for any long-distance travel, which is especially convenient for students without cars.",
  nearbyCitiesIntro: "We serve Rexburg and all Upper Valley communities including Sugar City, St. Anthony, Ashton, Rigby, and Driggs. We also serve travelers departing from Idaho Falls Regional Airport (IDA) and those connecting through Salt Lake City International Airport (SLC).",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Rexburg as simple as possible. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Rexburg travelers — especially students — start online and ship documents overnight. No office visit required.",
  mistakesIntro: "Upper Valley travelers encounter unique passport issues — from BYU-I study abroad acceptance letters arriving just weeks before departure to mission paperwork requiring fast turnaround. Here are the most common passport mistakes we see in Rexburg.",
  testimonialsIntro: "Rexburg and Upper Valley travelers — from BYU-I students to Sugar City families to St. Anthony professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Rexburg, ID? Here are the most common ones we hear from Upper Valley and BYU-Idaho travelers.",
  statePageRoute: "/states/idaho",
  statePageName: "Idaho",
  servicesIntro: "Whether you need a renewal before a mission departure, an emergency passport for a last-minute BYU-I international internship, or a first-time passport for your student heading abroad for the first time — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://itd.idaho.gov/dmv/",
  dmvLabel: "Idaho Transportation Department — DMV Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Closest agency is Denver (550 miles)", "Not practical for Upper Valley travelers"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned", "Daily status updates", "No need to travel anywhere"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "Updates only by physical mail", "Cannot upgrade speed after submission", "Not suitable if departure is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Mission departure in two days and passport is lost? International internship starting this week? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Rexburg travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Mission-Ready",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Rexburg residents renew fast — perfect for BYU-I students and Upper Valley professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide BYU-I students and Upper Valley residents through every step with clear instructions.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: "Student Essential",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 — especially critical when mission paperwork deadlines are approaching.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions for Upper Valley families traveling together.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage or a legal name change — common for newlyweds in Rexburg — we assist with corrected passports so your documents match.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: "Newlywed Help",
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda.",
      bullets: ["Wallet-size convenience", "Land and sea travel", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Rexburg ID", description: "Urgent passport processing for Rexburg Idaho travelers with immediate departure needs from Idaho Falls Airport." },
    { name: "Expedited Passport Renewal Rexburg ID", description: "Fast passport renewal for Rexburg Idaho residents with a previously-issued passport." },
    { name: "First-Time Passport Rexburg ID", description: "New passport application services for Rexburg Idaho residents and BYU-Idaho students." },
    { name: "Child Passport Rexburg ID", description: "Minor passport services for Rexburg Idaho families with children under 16." },
    { name: "Name Change Passport Rexburg ID", description: "Passport name correction after marriage or legal name changes for Rexburg residents." },
    { name: "Passport Card Rexburg ID", description: "Passport card services for land and sea crossings from Rexburg Idaho." },
  ],
  testimonials: [
    {
      name: "Tanner M.",
      location: "Rexburg — BYU-I Student",
      rating: 5,
      text: "Got my mission call with only 5 weeks until the MTC. Needed a new passport fast. Fast Passport Center processed it in 4 business days and caught a photo issue I would have missed. Made it to the MTC on time.",
      service: "New Passport",
    },
    {
      name: "Rachel & David P.",
      location: "Rexburg",
      rating: 5,
      text: "Got married and needed name change passports before our honeymoon in Italy. Fast Passport Center processed both in 6 days. The step-by-step guidance for marriage certificate documents was perfect.",
      service: "Name Change Passport",
    },
    {
      name: "The Christensen Family",
      location: "Sugar City",
      rating: 5,
      text: "All four of us needed passports for a family reunion in Mexico. Our kids had never had passports before. Fast Passport Center walked us through everything and all four arrived in 8 days.",
      service: "Family Passports",
    },
    {
      name: "Elder J. Thompson",
      location: "St. Anthony",
      rating: 5,
      text: "My passport was expiring right before my mission departure date. Fast Passport Center expedited the renewal in 5 business days. I was able to leave on time without any delays.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "rexburg-1",
      name: "Rexburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "140 S 3rd W",
      city: "Rexburg",
      state: "ID",
      zip: "83440",
      phone: "(208) 356-3919",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Rexburg — walkable from BYU-I campus",
      website: "https://tools.usps.com/find-location.htm?location=1377572",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility in Rexburg. Passport photos available. Very busy during BYU-I semester transitions — book 2+ weeks ahead during November and April.",
      icon: "ri-mail-line",
    },
    {
      id: "rexburg-2",
      name: "Madison County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "134 E Main St",
      city: "Rexburg",
      state: "ID",
      zip: "83440",
      phone: "(208) 356-3662",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Rexburg",
      website: "https://www.co.madison.id.us/clerk/",
      websiteLabel: "Madison County Clerk",
      notes: "County clerk passport acceptance services. Serves all Madison County residents. No photo services on-site — bring your own photos. Often has better availability than the post office.",
      icon: "ri-government-line",
    },
    {
      id: "rexburg-3",
      name: "Idaho Falls Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "600 W Sunnyside Rd",
      city: "Idaho Falls",
      state: "ID",
      zip: "83402",
      phone: "(208) 522-1372",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Idaho Falls — 30 miles south",
      website: "https://tools.usps.com/find-location.htm?location=1377536",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in eastern Idaho. Passport photos available. Good backup option if Rexburg appointments are full, especially during BYU-I semester rush.",
      icon: "ri-mail-line",
    },
    {
      id: "rexburg-4",
      name: "St. Anthony Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "48 W 1st N",
      city: "St. Anthony",
      state: "ID",
      zip: "83445",
      phone: "(208) 624-3538",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "St. Anthony — 12 miles north",
      website: "https://tools.usps.com/find-location.htm?location=1377580",
      websiteLabel: "USPS Location",
      notes: "Smaller acceptance facility serving St. Anthony and northern Fremont County. Limited appointment slots — book well in advance.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver agency is 550 miles away", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 550 miles to Denver or fly there", fpc: "Most Rexburg travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel with proof of departure", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "BYU-I & Mission Expertise", agency: "Generic — no student or mission timeline knowledge", fpc: "Full BYU-I student, mission, and Upper Valley knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Mission Call to MTC Timeline Compression",
      description: "BYU-I students receiving mission calls often have just 4–8 weeks between acceptance and MTC departure. First-time passport applicants need both an acceptance facility visit and processing time — starting 2 weeks before the MTC date is a recipe for disaster.",
    },
    {
      icon: "ri-error-warning-line",
      title: "BYU-I Study Abroad Acceptance Rush",
      description: "BYU-Idaho study abroad programs frequently notify students of acceptance just 5–8 weeks before departure. Many students — especially freshmen — have never had passports and underestimate the time required for the application and processing cycle.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Issues from Local Retailers",
      description: "The high volume of passport photos needed in Rexburg means local retailers process hundreds during peak seasons. Photos from big-box stores frequently fail State Department standards — wrong background, shadows, head size issues. We catch these before they cause rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Name Change Delays for Newlyweds",
      description: "Rexburg has one of the highest marriage rates in the country. Newlyweds planning international honeymoons often do not account for the time needed to process a legal name change and then get a corrected passport before departure.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Holiday Semester Breaks",
      description: "December and April are peak passport months as students prepare for study abroad, missions, and semester break international travel. Acceptance facility appointments fill 3–4 weeks in advance during these periods. Start the process well before finals week.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel or mission date and complete your secure order. Takes just a few minutes from your dorm, apartment, or home." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your specific travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Rexburg clients ship from the UPS Store on University Blvd or the Rexburg Post Office." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 550 miles to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no stressing — just certainty and peace of mind." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Rexburg?", a: "We offer Rexburg-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Can BYU-Idaho students apply for passports on campus?", a: "BYU-Idaho does not have an on-campus passport acceptance facility. Students should use the Rexburg Post Office (walkable from campus) or the Madison County Clerk for their acceptance visit. We provide step-by-step guidance for BYU-I students." },
    { q: "I have a mission call with a tight timeline — can you help?", a: "Absolutely. We specialize in fast-turnaround passports for missionaries. Many Rexburg missionaries work with us because we understand the MTC timeline and the urgency of mission paperwork. As fast as 24 hours for emergency situations." },
    { q: "Where is the closest passport agency to Rexburg?", a: "The Denver Passport Agency is approximately 550 miles away. It requires appointments and serves life-or-death emergencies only. For all practical expedited needs, our courier channel is faster and eliminates long-distance travel." },
    { q: "Can you help with flights from Idaho Falls Airport?", a: "Yes. Idaho Falls Regional Airport (IDA) is just 30 minutes from Rexburg with connections to Salt Lake City, Denver, Seattle, and Phoenix — all major international gateway hubs." },
    { q: "What documents do Rexburg applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Rexburg-specific checklist." },
    { q: "Where can I get passport photos in Rexburg?", a: "The Rexburg Post Office, Walmart on 2nd East, and the UPS Store on University Blvd all offer passport photo services. During BYU-I semester transitions, book photo appointments early as demand is extremely high." },
    { q: "What is the best price for expedited service in Rexburg?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers." },
    { q: "How do I check my Rexburg passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Rexburg to final return shipping typically matches your chosen speed tier." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Rexburg Residents",
    intro: "Rexburg is unique — a small city with the international travel demand of a much larger one, driven almost entirely by BYU-Idaho's 20,000+ student body. Here's what Upper Valley travelers need to know about passport timing.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "IDA — Idaho Falls Regional Airport",
        subtitle: "Primary commercial airport for eastern Idaho, 30 minutes from Rexburg",
        description: "Idaho Falls Regional Airport (IDA) connects eastern Idaho to major U.S. hubs — Salt Lake City, Denver, Seattle, and Phoenix — where travelers link to international flights worldwide. The 30-minute drive from Rexburg makes international connections accessible, but the compression of BYU-I academic calendars means hundreds of students need passports simultaneously during semester transitions.",
        tip: "IDA connections to Salt Lake City (SLC) are the most common international gateway for Rexburg travelers. Your passport must be valid at IDA check-in for international connections, not just at SLC.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "BYU-Idaho Study Abroad & International Internships",
        subtitle: "Hundreds of students traveling internationally each semester",
        description: "BYU-Idaho sends students to over 40 countries each year through study abroad programs, international internships, and field studies. Programs range from business internships in London and Shanghai to humanitarian projects in Guatemala and Peru. The acceptance-to-departure window is typically 5–8 weeks, and many students — especially freshmen and sophomores — have never held passports.",
        tip: "If you are applying to a BYU-I study abroad or international internship, begin your passport process before submitting the application. Waiting until acceptance creates a time crunch that is entirely avoidable.",
      },
      {
        icon: "ri-globe-line",
        title: "Church Mission & Service Travel",
        subtitle: "One of the highest concentrations of international mission departures in the U.S.",
        description: "Rexburg likely has more international mission departures per capita than any other city in the United States. Missionaries typically receive their call 4–10 weeks before MTC departure, with destinations ranging from Brazil and the Philippines to Japan and France. The passport and visa timeline is compressed, and the consequences of missing a departure date due to documentation issues are significant.",
        tip: "Missionaries should begin their passport application process immediately upon receiving their call. The acceptance facility visit should be scheduled within the first week to ensure enough processing time before MTC departure.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Rexburg & the BYU-I Semester Effect",
      description: "The Rexburg passport market is unlike any other. Demand spikes dramatically in November (before Winter Semester study abroad), March–April (before Spring Term international programs), and July–August (before Fall Semester departures). Acceptance facility appointments fill 3–4 weeks in advance during these periods. Plan accordingly.",
    },
  },
  destinations: {
    title: "Where Rexburg Travelers Go — And Why Passports Get Urgent",
    intro: "Rexburg's international travel patterns are dominated by BYU-Idaho students and missionaries, creating demand patterns unlike anywhere else in Idaho.",
    stats: [
      { stat: "60%", label: "of Rexburg expedited requests are student-related — study abroad, missions, international internships" },
      { stat: "4–8 Weeks", label: "average time between mission call receipt and MTC departure date" },
      { stat: "Nov & Apr", label: "peak months when semester transitions, mission calls, and international programs converge" },
      { stat: "5 Days", label: "typical turnaround for Rexburg-area expedited passport processing" },
    ],
    destinations: [
      { name: "Latin America", context: "Mission assignments in Brazil, Mexico, Peru, Guatemala, Argentina, Chile, Colombia", urgency: "Mission calls with 4–8 weeks to MTC, visa processing adds complexity", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "BYU-I study abroad in London, Paris, Rome, Madrid; missions in France, Germany, Portugal", urgency: "Program acceptance to departure often just 5–7 weeks", icon: "ri-map-pin-2-line" },
      { name: "Asia & Pacific", context: "Missions in Japan, Philippines, South Korea, Taiwan; BYU-I internships in Shanghai, Tokyo", urgency: "Visa processing for Asian countries adds 2–4 weeks to passport timeline", icon: "ri-map-pin-2-line" },
      { name: "Africa", context: "Humanitarian service trips, missions in Ghana, Nigeria, South Africa, Mozambique", urgency: "Additional vaccination and visa requirements compound passport timelines", icon: "ri-map-pin-2-line" },
      { name: "Canada & Mexico", context: "Upper Valley family vacations, semester break road trips, border-region service projects", urgency: "Families often discover expired documents when packing for summer road trips", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Eastern Idaho Service Areas",
    crossLinksDesc: "We serve travelers across eastern Idaho with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Idaho Falls", route: "/cities/idaho-falls" },
      { name: "Pocatello", route: "/cities/pocatello" },
    ],
  },
  photoLocations: [
    { name: "Rexburg Post Office", address: "140 S 3rd W, Rexburg, ID 83440", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Walmart — Rexburg", address: "1450 N 2nd E, Rexburg, ID 83440", hours: "Daily 6 AM – 11 PM" },
    { name: "The UPS Store — Rexburg", address: "160 W 2nd S, Rexburg, ID 83440", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM" },
    { name: "Idaho Falls Post Office", address: "600 W Sunnyside Rd, Idaho Falls, ID 83402", hours: "Mon–Fri 9 AM – 4 PM" },
  ],
  dmvLocations: [
    {
      name: "Madison County DMV — Rexburg",
      address: "134 E Main St, Rexburg, ID 83440",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment strongly recommended during BYU-I semester transitions.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "IDA",
      name: "Idaho Falls Regional Airport",
      distance: "About 30 minutes from Rexburg",
      address: "2140 N Skyline Dr, Idaho Falls, ID 83402",
      note: "Regional airport with flights to Salt Lake City, Denver, Seattle, and Phoenix. Major gateway for international connections from eastern Idaho.",
      flightUrl: "https://www.idahofallsidaho.gov/803/Airport",
      flightLabel: "IDA Airport Website",
      featured: true,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from Idaho Vital Records. Online, mail, or in-person options available for Madison County.",
      url: "https://healthandwelfare.idaho.gov/services-programs/birth-death-marriage-divorce",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Idaho Vital Records. Required for estate and legal matters in Madison County.",
      url: "https://healthandwelfare.idaho.gov/services-programs/birth-death-marriage-divorce",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Madison County Clerk. Certified copies available for newlywed name changes.",
      url: "https://www.co.madison.id.us/clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Madison County District Court. Required for name change passport corrections.",
      url: "https://www.co.madison.id.us/courts/",
    },
  ],
};